require('dotenv').config();
import 'babel-polyfill';
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
import moment from 'moment';
import Vue from 'vue';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';

Vue.use(BootstrapVue);
Vue.use(Vuex);

Vue.component(
	'filter-boolean',
	require('./components/Filters/Boolean').default
);
Vue.component('filter-text', require('./components/Filters/Text').default);
Vue.component('filter-select', require('./components/Filters/Select').default);
Vue.component('filter-date', require('./components/Filters/Date').default);
Vue.component('field-date', require('./components/Fields/Date').default);
Vue.component('field-boolean', require('./components/Fields/Boolean').default);

moment.locale('NL');

/* eslint-disable no-new */
window.app = new Vue({
	el: '#app',
	router,
	template: '<App/>',
	components: {
		App,
	},
	store,
});
